import React from 'react'
import { Typography } from '@mui/material'
import FolderOffIcon from '@mui/icons-material/FolderOff'

/**
 * Non-functional "Browse files" slot for Step 1 of the Gen AI Insights wizard
 * (#970 Part A). Deliberately inert — file selection is out of scope for this
 * change (see issue #970 "Out of scope / follow-ups"). The slot exists so the
 * eventual feature has a fixed home in the layout rather than needing a
 * redesign — but it is ONE quiet line (#1176): the padded card with its own
 * subtitle pushed the table tree, the screen's main control, into a strip.
 */
export const FilesComingSoonSlot: React.FC = () => (
  <Typography
    variant="caption"
    color="text.secondary"
    sx={{ display: 'flex', alignItems: 'center', gap: 0.75, opacity: 0.75 }}
  >
    <FolderOffIcon sx={{ fontSize: 14 }} />
    Browse files (Excel, PowerPoint, PDF from this job&apos;s Files area) — coming soon.
  </Typography>
)

export default FilesComingSoonSlot
